let nodeEnv = "";
let domain = window.location.hostname || "";
if (domain === "poweris.inhand.online") {
  nodeEnv = "production_cn";
} else if (domain === "poweris.inhandnetworks.com") {
  nodeEnv = "production_global";
} else if (domain === "cloud-dev.poweris.inhand.online") {
  nodeEnv = "development";
} else {
  nodeEnv = "local";
}

let config = null;

switch (nodeEnv) {
  case "production_cn":
    config = {
      BASE: "https://poweris.inhand.online",
      CLIENT_ID: "60ab5b7cb4705f274175f87f",
      CLIENT_SECRET: "57f4d08c-6ab8-4684-a0d9-0b414c814378",
      X_API_KEY: "0031c695-0c2f-4bd4-a036-5c6217b861ff",
    };
    break;
  case "production_global":
    config = {
      BASE: "https://poweris.inhandnetworks.com",
      CLIENT_ID: "60ab5b7cb4705f274175f87f",
      CLIENT_SECRET: "5554d08c-6ab8-4684-a0d9-0b414c814c10",
      X_API_KEY: "48e8e814-3eaa-4c11-bc9e-f5092f755739 ",
    };
    break;
  case "development":
    config = {
      BASE: "https://cloud-dev.poweris.inhand.online",
      CLIENT_ID: "60f66b50851822bf0a592ff7",
      CLIENT_SECRET: "odoo_test",
      X_API_KEY: "80e5ea37-1298-4691-9f55-111e708eba95",
    };
    break;
  case "local":
    config = {
      BASE: "",
      CLIENT_ID: "60f66b50851822bf0a592ff7",
      CLIENT_SECRET: "odoo_test",
      X_API_KEY: "80e5ea37-1298-4691-9f55-111e708eba95",
    };
    break;
  default:
    break;
}
console.log("config", config);
const { BASE, CLIENT_ID, CLIENT_SECRET, X_API_KEY } = config;

export { BASE, CLIENT_ID, CLIENT_SECRET, X_API_KEY };
